<div class="settings-header">
    <div class="header-left">
        <button *ngIf="showBackButton" class="back-button" mat-button (click)="onBack()">
            <mat-icon>chevron_left</mat-icon>
        </button>
        <h2 class="header-title">{{ title | translate }}</h2>
    </div>
    <button *ngIf="showCreateButton" mat-flat-button color="primary" class="create-button" (click)="onCreate()">
        {{ createButtonTranslationKey | translate }}
    </button>
</div> 